import { useNavigate } from 'react-router-dom';
import { Plus, MessageSquare } from 'lucide-react';
import { useState } from 'react';
import SiteHeader from '../components/SiteHeader';
import Footer from '../components/Footer';
import useAuthModal from '../hooks/useAuthModal';

export default function ChatsListScreen() {
  const navigate = useNavigate();
  const authModal = useAuthModal();
  const [chats, setChats] = useState([
    {
      id: 1,
      title: 'Software Engineer Interview Prep',
      lastMessage: 'Could you describe a challenging technical problem...',
      updatedAt: 'Today 14:32',
      unread: false,
    },
    {
      id: 2,
      title: 'General Career Questions',
      lastMessage: 'What skills should I focus on for a senior role?',
      updatedAt: 'Yesterday',
      unread: true,
    },
    {
      id: 3,
      title: 'Resume Review Discussion',
      lastMessage: 'Your resume looks great! Let me suggest some improvements...',
      updatedAt: '2 days ago',
      unread: false,
    },
  ]);

  const handleCreateNewChat = () => {
    const newChatTitle = prompt('Enter chat name (e.g., "Interview Prep"):');
    if (newChatTitle && newChatTitle.trim()) {
      const newChat = {
        id: chats.length + 1,
        title: newChatTitle,
        lastMessage: 'Chat created. Type your first message...',
        updatedAt: 'Just now',
        unread: false,
      };
      setChats([newChat, ...chats]);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f8f8] flex flex-col">
      <SiteHeader authModal={authModal} />

      {/* Content */}
      <main className="flex-grow overflow-y-auto p-6 space-y-4">
        <h1 className="text-3xl font-bold text-[#212B36] mb-6">AI Chats</h1>

        {chats.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12">
            <MessageSquare className="w-16 h-16 text-gray-400 mb-4" />
            <p className="text-gray-600 text-lg font-medium mb-2">
              Start a conversation with your AI career assistant
            </p>
            <p className="text-gray-500 text-sm text-center mb-6">
              Get help with interview prep, resume review, and career advice
            </p>
            <button
              onClick={handleCreateNewChat}
              className="btn-orange px-6 py-3"
            >
              Create First Chat
            </button>
          </div>
        ) : (
          chats.map((chat) => (
            <button
              key={chat.id}
              onClick={() => navigate('/chat')}
              className="card text-left hover:shadow-lg transition w-full"
            >
              <div className="flex items-start justify-between">
                <div className="flex-grow">
                  <h3 className="text-lg font-bold text-gray-900">
                    {chat.title}
                    {chat.unread && (
                      <span className="ml-2 inline-block w-2 h-2 bg-blue-500 rounded-full"></span>
                    )}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                    {chat.lastMessage}
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    {chat.updatedAt}
                  </p>
                </div>
              </div>
            </button>
          ))
        )}
      </main>

      <Footer />

      {/* FAB - Create New Chat */}
      <button
        onClick={handleCreateNewChat}
        className="fixed bottom-8 right-8 w-16 h-16 bg-orange-500 text-white rounded-full shadow-lg hover:bg-orange-600 transition flex items-center justify-center"
      >
        <Plus className="w-8 h-8" />
      </button>
    </div>
  );
}
